import React, { useState, useEffect } from 'react';
import { useStore } from '../context/store';

export default function Search() {
	const { state, dispatch } = useStore();

	let timer = 0;

	const startSearchTimeout = function (value) {
		if ('undefined' !== typeof timer) {
			clearTimeout(timer);
		}

		timer = setTimeout(() => {
			dispatch({ type: 'setSearchQuery', payload: value });
		}, 250);
	};

	const clearTimer = function () {
		clearTimeout(timer);
	};

	return (
		<div className="tf-search">
			<input
				type="search"
				className="tf-search__input"
				placeholder="Search"
				aria-label="Term to search"
				value={state.searchText}
				onChange={(e) =>
					dispatch({ type: 'setSearchText', payload: e.target.value })
				}
				onKeyUp={(e) => startSearchTimeout(e.target.value)}
				onKeyDown={(e) => clearTimer()}
				autoComplete="off"
			/>

			<button className="tf-search__submit" role="submit">
				<span className="sr-only">Search trips</span>
			</button>
		</div>
	);
}
